module.exports = {
    createEmptyPromise: function () {
        return new Promise(function (resolve) {
            resolve();
        });
    },

    isElementInViewport: function (el, topOffset, bottomOffset) {
        if (typeof jQuery === 'function' && el instanceof jQuery) {
            el = el[0];
        }

        if (!topOffset) {
            topOffset = 0;
        }

        if (!bottomOffset) {
            bottomOffset = 0;
        }

        var rect = el.getBoundingClientRect();

        return (
            rect.top - topOffset >= 0 &&
            rect.left >= 0 &&
            rect.bottom + bottomOffset <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/utils/Utils.js
// module id = 13
// module chunks = 0